import "./button.scss";
import Arrow from '../../../assets/images/icons/chevron.png';
import Logout from '../../../assets/images/icons/logout.png';
import Unlock from '../../../assets/images/icons/unlock.png';
import Add from '../../../assets/images/icons/add.png';
import Swap from '../../../assets/images/icons/return.png';
import Register from '../../../assets/images/icons/register.png';
import Login from '../../../assets/images/icons/enter.png';

import { DotLoader } from "../loader/loader";
import { useAppSelector } from "../../../features";
import { getNotificationButtonLoad } from "../../../store/NotificationSlice";
import { useEffect } from "react";

type ActionButtonProps = {
    label: string,
    onClick: () => void;
    disabled?: boolean;
    direction?: string;
    less?: string;
    loading?: boolean;
    type?: string;
    step?: string
}

export const Button: React.FC<ActionButtonProps> = (props) => {

    const isButtonLoading = useAppSelector(getNotificationButtonLoad);
    let disabled : boolean = false;

    useEffect( () => {
        disabled = props.disabled || isButtonLoading;
    },[props.disabled, isButtonLoading]);

    const handleClick = () => {
        if (!props.disabled) props.onClick();
    }

    const imagetoShow = () => {
        if (props.type?.includes("logout")) return Logout;
        
        switch(props.type) {
            case "unlock":
                return Unlock;
            case "add":
                return Add;
            case "register":
                return Register;
            case "swap":
                return Swap;
            case "login":
                return Login;                
            default:
                return Arrow
        }
    }

    const type = () : string => {
        if (props.type) return props.type
        return ''
    }

    return (
        <>
            <button 
            className={`btn btn-register-green margin-top ${props.step} ${props.direction} ${props.less} ${type()}`}
            onClick={handleClick}
            disabled={props.disabled}>
                { isButtonLoading && (
                    <DotLoader />
                )}
                { !isButtonLoading && (
                    <>
                        {props.label}
                        <img src={imagetoShow()} className={type()} alt="arrow"/>
                    </>
                )}
            </button>
        </>
    )
}